<template>
  <app-modal ref="modal" name="create-virtual-invoice-form-modal" :title="title"  @before-open="beforeOpen" :okText="$t('invoice.createPaymentVoucher')" :is-submitting="isLoading"  @before-close="beforeClose" @on-ok="onOk">
    <app-form ref="form"
              @on-submit="onSubmit"
              :schema="schema"
              :data="formModel"
              @on-input="onFormFieldChanged"
    >
    </app-form>
  </app-modal>
</template>
<script>

import AppModal from '@/components/app-modal/';
import AppForm from '@/components/app-form/index';
import InvoiceProxy from '@/store/proxies/invoice-proxy';


const formSchema = context => ({
  document: {
    label: 'File',
    placeholder: `${context.$t('app.enter')} File`,
    inputType: 'file',
    type: 'input',
    validation: 'required',
  },
  total_amount_without_tax: {
    label: context.$t('invoice.Amount'),
    placeholder: `${context.$t('app.enter')} ${context.$t('invoice.Amount')}`,
    type: 'currency',
    validation: 'required',
  },
  tax_percentage: {
    label: `${context.$t('invoice.tax')} (%)`,
    placeholder: `${context.$t('app.enter')} % ${context.$t('invoice.tax')}`,
    inputType: 'number',
    type: 'input',
    validation: 'required',
  },
  total_amount_with_tax: {
    label: context.$t('invoice.theAmountAfterTax'),
    placeholder: `${context.$t('app.enter')} ${context.$t('invoice.theAmountAfterTax')}`,
    type: 'currency',
    validation: 'required',
  },
  content: {
    label: context.$t('invoice.content'),
    placeholder: `${context.$t('app.enter')} ${context.$t('invoice.content')}`,
    type: 'textarea',
    validation: 'required',
  },
});

export default {
  name: 'CreateVirtualInvoiceFormModal',
  components: {
    AppForm,
    AppModal,
  },
  data() {
    return {
      isMobile: false,
      title: this.$t('invoice.createPaymentVoucher'),
      schema: [],
      formModel: {
        document: null,
        total_amount_without_tax: null,
        total_amount_with_tax: null,
        tax_percentage: null,
        content: null,
      },
      uploadStatus: {
        count: 0,
        uploading: false,
        percentCompleted: 0,
      },
      isLoading: false,
    };
  },
  computed: {
  },
  methods: {
    onOk() {
      this.$refs.form.submit();
    },
    onSubmit(formModel, validate, { resolve }) {
      this.$refs.form.validate().then((isValid) => {
        if (isValid) {
          this.isLoading = true;
          const request = new InvoiceProxy().uploadVirtualInvoice(formModel, this.uploadStatus);
          request.then((res) => {
            resolve(res);
            this.$refs.modal.close();
            this.$router.push({ name: 'main.payment-receipt', query: this.$route.query }).catch(() => {});
          }).finally(() => {
            setTimeout(() => {
              this.isLoading = false;
            }, 500);
          });
        }
      });
    },
    beforeClose() {
      this.formModel = {
        document: null,
        total_amount_without_tax: null,
        total_amount_with_tax: null,
        tax_percentage: null,
        content: null,
      };
    },
    beforeOpen() {
      this.schema = formSchema(this);
    },
    onFormFieldChanged($event, field) {
      const formVm = this.$refs.form;
      if (!field) {
        return;
      }
      const vat = formVm.getFieldValue('tax_percentage') || 0;
      if (field.name === 'total_amount_without_tax') {
        formVm.setFieldValue('total_amount_with_tax', `${Math.round(parseInt(field.value, 0) * ((100 + parseInt(vat, 0)) / 100))}`);
        return;
      }
      if (field.name === 'tax_percentage') {
        const amount = formVm.getFieldValue('total_amount_without_tax') || 0;
        formVm.setFieldValue('total_amount_with_tax', `${Math.round(parseInt(amount, 0) * ((100 + parseInt(field.value, 0)) / 100))}`);
      }
    },
  },
};
</script>



// WEBPACK FOOTER //
// src/portal-components/invoice/create-virtual-invoice-form-modal.vue